import * as React from "react";
import styles from "./AuthLayout.module.css";

interface AuthLayoutProps {
  brandContent: React.ReactNode;
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ brandContent, children }) => (
  <div className={styles.page}>
    <aside className={styles.brand}>
      <div className={styles.blobsLayer}>
        <div className={styles.blob1} />
        <div className={styles.blob2} />
        <div className={styles.blob3} />
      </div>
      <div className={styles.gridOverlay} />

      <div className={styles.brandLogo}>
        <img src="/logo.png" alt="X5 Real Estate" className={styles.brandLogoImg} />
      </div>

      <div className={styles.brandBody}>
        {brandContent}
      </div>

      <div className={styles.brandStats}>
        <div>
          <div className={styles.statValue}>12</div>
          <div className={styles.statLabel}>проектов</div>
        </div>
        <div>
          <div className={styles.statValue}>25</div>
          <div className={styles.statLabel}>разделов РД</div>
        </div>
        <div>
          <div className={styles.statValue}>24/7</div>
          <div className={styles.statLabel}>доступ</div>
        </div>
      </div>
    </aside>

    <section className={styles.formPanel}>
      {children}
    </section>
  </div>
);
